/**
 * PDF.js setup shared by the app entry.
 *
 * IMPORTANT: react-pdf's own index.js resets
 *   GlobalWorkerOptions.workerSrc = 'pdf.worker.mjs'
 * every time it is imported. Configure the worker again in every module that
 * imports Document/Page (see AuditPdfViewer.js) — otherwise the relative
 * "pdf.worker.mjs" path 404s as HTML and the viewer shows
 * "Could not open this PDF in the viewer."
 */
import { pdfjs } from 'react-pdf';

if (typeof Promise.withResolvers !== 'function') {
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

if (typeof window !== 'undefined') {
  pdfjs.GlobalWorkerOptions.workerSrc =
    `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
}
